import { InjectionToken } from '@angular/core';
import type { CappusErrorHandler } from './cappus-error-handler';

export const ERROR_HANDLER_INJECTION_TOKEN = new InjectionToken<CappusErrorHandler[]>(
  'cappus_error_handler',
);
